/**
 * Created by akirilyuk on 9/13/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/caseCommentView.tmpl"),
        CaseCommentItemView = require("connection-views/ticketTab/extendedList/CaseCommentItemView"),
        CaseCommentView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        CaseCommentView = Marionette.CompositeView.extend({
            template: template,
            className: 'case-comment-view',
            itemViewContainer: ".case-comment-container",
            itemView: CaseCommentItemView,

            initialize: function (options){
                this.$el = options.el ;
                this.collection = options.collection;
                this.index = 0;
            },

            onRender: function(){
                $(this.$el).append(this.el);
            },

            onAfterItemAdded: function(itemView){
                if(this.index%2===0){
                    itemView.setOdd();
                }
                this.index++;
            }
        });
    });
    return CaseCommentView;
});
